import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

console.log('Loaded env:', process.env.REACT_APP_ENV);
console.log('running in', process.env.NODE_ENV)
if (process.env.NODE_ENV !== 'production') {
  console.log('we are NOT in prod :D')
}
console.info("Versión:", process.env.REACT_APP_VERSION);